<div class="flex">
  <div class="transition-width" [class.full-width]="!selectedContainerType" [class.two-thirds-width]="selectedContainerType">
    <h1 class="main-title">
      <div class="circle circle-primary">
        <img src="assets/icons/toolbox-icon.svg" alt="">
      </div>
      Tipos de envases
    </h1>
    <div class="flex justify-between items-center mb-2">
      <h2 class="main-subtitle">Todos los tipos de envases</h2>
      <a routerLink="/container-types/create" class="button button-success">
        <i class="fa-solid fa-plus" alt=""></i> Nuevo tipo
      </a>
    </div>

    <div class="single-page-content">
      <app-table [columns]="tableColumns" [data]="containerTypes">
        <ng-template #actionTemplate let-containerType>
          <div class="action-buttons">
            <button (click)="selectContainerType(containerType)" title="Ver">
              <img src="assets/icons/eye-icon.svg" alt="">
            </button>
            <a routerLink="/container-types/update/{{containerType.id}}" title="Editar">
              <img src="assets/icons/pencil-icon.svg" alt="">
            </a>
            <button (click)="confirmDelete(containerType)" title="Eliminar">
              <img src="assets/icons/trashcan-icon.svg" alt="">
            </button>
          </div>

          <!--
            <a (click)="selectContainerType(containerType)" class="text-blue-600 focus:outline-none cursor-pointer">
              <svg class="w-5 h-5" fill="currentColor" viewBox="0 0 24 24">
                <path d="M13.5 6c-2.88 0-5.5 2.62-5.5 5.5s2.62 5.5 5.5 5.5 5.5-2.62 5.5-5.5-2.62-5.5-5.5-5.5zm0 9.5c-2.07 0-3.75-1.68-3.75-3.75S11.43 7 13.5 7s3.75 1.68 3.75 3.75-1.68 3.75-3.75 3.75z"/>
              </svg>
            </a>
            <a routerLink="/container-types/update/{{containerType.id}}" class="text-blue-600 focus:outline-none">
              <svg class="w-5 h-5" fill="currentColor" viewBox="0 0 24 24">
                <path d="M3 17.25V21h3.75L17.81 9.94l-3.75-3.75L3 17.25zM20.71 7.04c.39-.39.39-1.02 0-1.41l-2.34-2.34c-.39-.39-1.02-.39-1.41 0l-1.83 1.83 3.75 3.75 1.83-1.83z"/>
              </svg>
            </a>
            <button (click)="confirmDelete(containerType)" class="text-red-600 focus:outline-none">
              <svg class="w-5 h-5" fill="currentColor" viewBox="0 0 24 24">
                <path d="M3 6L5 6 21 6 21 8 3 8 3 6zm3 2v12c0 1.1.9 2 2 2h8c1.1 0 2-.9 2-2V8H6zm2 0h8v12H8V8zm2-2V4h4v2H10z"/>
              </svg>
            </button>
            <button (click)="toggleContainerTypeStatus(containerType)" class="text-yellow-600 focus:outline-none">
              <svg class="w-5 h-5" fill="currentColor" viewBox="0 0 24 24">
                <path *ngIf="!containerType.disabled" d="M12 17c-1.1 0-2-.9-2-2v-2h2v2h8v-2h2v2c0 1.1-.9 2-2 2h-8zm6-10v-2c0-1.1-.9-2-2-2h-4c-1.1 0-2 .9-2 2v2h8zm-2 0h-4v-2h4v2z"/>
                <path *ngIf="containerType.disabled" d="M20 8h-2V6c0-2.76-2.24-5-5-5S8 3.24 8 6v2H6c-1.1 0-2 .9-2 2v10c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V10c0-1.1-.9-2-2-2zm-4-2c0-1.66-1.34-3-3-3s-3 1.34-3 3v2h6V6zm-3 12h-4v-2h4v2zm0-4h-4v-2h4v2z"/>
              </svg>
            </button>
          -->
        </ng-template>
      </app-table>
      <app-confirm-popup *ngIf="containerTypeToDelete" [message]="'¿Estás seguro de que quieres eliminar este Tipo de Envase?'" (onConfirm)="onDeleteConfirm()" (onCancel)="onDeleteCancel()"></app-confirm-popup>
    </div>
  </div>

  <div class="one-third-width pl-4 transition-width" *ngIf="selectedContainerType">
    <app-container-type-detail [containerType]="selectedContainerType" (closeDetail)="closeContainerTypeDetail()"></app-container-type-detail>
  </div>
</div>
